interface ZoneLike {
  i?: string;
  id?: string;
  t?: string;
  type?: string;
  l?: string;
  label?: string;
}

const TYPE_WEIGHT: Record<string, number> = { CI: 1, City: 1, DI: 2, District: 2, RE: 3, Region: 3, TO: 4, Town: 4, ZI: 10, Zip: 10 };

/**
 * The title a search gets when the user leaves "Name" empty: its broadest zones (cities
 * before districts before PLZ), else its PLZ. Shared by the overview (DashboardHome) and
 * the editor, where it is the Name field's placeholder.
 */
export function defaultSubscriptionTitle(zones: ZoneLike[] | undefined, zipCodes: string[] | undefined): string {
  if (zones && zones.length > 0) {
    // Normalize zones to handle both old and new data formats
    const normalized = zones.map((z) => ({ i: z.i || z.id, t: z.t || z.type || '', l: z.l || z.label }));
    const prioritized = [...normalized].sort((a, b) => (TYPE_WEIGHT[a.t] || 5) - (TYPE_WEIGHT[b.t] || 5));
    const names = prioritized.map((z) => z.l || z.i).slice(0, 3).join(', ');
    const remainingCount = prioritized.length - 3;
    return `${names}${remainingCount > 0 ? ` +${remainingCount}` : ''}`;
  }

  if (zipCodes && zipCodes.length > 0) {
    if (zipCodes.length > 5) {
      return `${zipCodes.slice(0, 5).join(', ')} ... (${zipCodes.length} gesamt)`;
    }
    return zipCodes.join(', ');
  }

  return 'Keine PLZ (bitte hinzufügen)';
}
